module.exports = __webpack_public_path__ + "static/media/lobo-guara_thumb.18a78bd2.jpg";